"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialButtons = void 0;
const react_1 = __importDefault(require("react"));
const css_manager_1 = require("@food/css-manager");
const icons_1 = require("@food/ui/build/dist/src/icons");
const types_1 = require("../types");
const socialButtons = (0, css_manager_1.registerClass)((t, sc) => `
	> button {
		display: flex;
		width: 100%;
		cursor: pointer;
		text-align: left;
		border: none;
		margin-bottom: ${t.font.baseSize}px;
		align-items: stretch;
		padding: ${t.font.baseSize}px;
		font-size: ${t.font.baseSize}px;
		
		> span {
			&:first-child {
				font-size: ${t.ratios.l * t.font.baseSize}px;
				flex-shrink: 1;
				display: flex;
				align-items: center;
			}
			&:last-child {
				flex-grow: 1;
				text-align: left;
				padding-left: ${t.font.baseSize}px;
				display: flex;
				align-items: center;
			}
		}

		&.${sc('GOOGLE')} {
			color: ${t.colors.white};
			background-color: #d34836;
		}
		&.${sc('FACEBOOK')} {
			color: ${t.colors.white};
			background-color: #3b5998;
		}
		&.${sc('LINKEDIN')} {
			color: ${t.colors.white};
			background-color: #0a74b4;
		}
		&.${sc('APPLE')} {
			color: ${t.colors.white};
			background-color: #000000;
		}
	}
`);
function social2icon(s) {
    switch (s) {
        /*		case SOCIAL.FACEBOOK:
                    return 'facebook';*/
        case types_1.SOCIAL.GOOGLE:
            return 'google';
        case types_1.SOCIAL.LINKEDIN:
            return 'linkedin';
        case types_1.SOCIAL.APPLE:
            return 'apple';
        default:
            return 'share';
    }
}
const SocialButtons = ({ socials, onClick, t, }) => (react_1.default.createElement("div", { className: socialButtons }, socials.map((social) => (react_1.default.createElement("button", { key: social, className: (0, css_manager_1.subClass)(socialButtons, social), onClick: () => onClick !== undefined && onClick({ fixedSocial: social }) },
    react_1.default.createElement(icons_1.Icon, { name: social2icon(social) }),
    react_1.default.createElement("span", null, t(`${social} login button`, `Sign in with ${social}`)))))));
exports.SocialButtons = SocialButtons;
//# sourceMappingURL=SocialButtons.js.map